export async function getMicrophonePermissionState(): Promise<
  'unknown' | 'prompt' | 'granted' | 'denied'
> {
  // Check if permissions API available -- if it's not, permission is unknown until we ask.
  if (typeof window === 'undefined') return 'unknown';
  if (typeof window.navigator === 'undefined') return 'unknown';
  if (!window.navigator.permissions) return 'unknown';

  // See https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API#browser_compatibility
  // for compatibility of specific permissions
  // On Chrome & Edge 'microphone' permission checking is supported
  // On Firefox it is not -- so we are unknown until we ask.
  // On Safari that supports permissions api, 'microphone' permission checking is supported

  try {
    const permissionStatus = await navigator.permissions.query({
      name: 'microphone' as PermissionName,
    });

    // permissionStatus.onchange = function stateChange(this: PermissionStatus) {
    //   console.log(`Permission changed to ${this.state}`);
    // };

    return permissionStatus.state;
  } catch (err) {
    return 'unknown';
  }
}
